export const TEMPLATE_VARS_OPENING = {
  STRIKE_THROUGH: '<s>',
  BOLD: '<b>',
  ANCHOR: '<a>',
  HYPERLINK: '<h>',
  TEL: '<t>',
  REPLACE: '<r>',
  FONT_SIZE: '<fs>',
  FONT_WEIGHT: '<fw>',
  URL: '<url>',
  STYLE: '<style>',
  TARGET: '<target>',
  UNORDERED_LIST: '<ul>',
  LIST_ITEM: '<li>',
  MARGIN: '<m>',
  MARGIN_LEFT: '<ml>',
  MARGIN_RIGHT: '<mr>',
  LINE_HEIGHT: '<leading>',
  DISPLAY: '<d>',
  FLEX_DIR: '<fd>',
  GAP: '<g>',
  TEXT_DECORATION: '<td>',
  TEXT_DECORATION_STYLE: '<tds>',
  TEXT_UNDERLINE_OFFSET: '<tuo>',
  SPAN: '<span>',
  COLOR: '<color>',
  SRC: '<src>',
  DIV: '<div>',
  ICON: '<icon>',
  UNICODE: '<unicode>',
  ORDERED_LIST: '<ol>',
  BG: '<bg>',
  TG: '<tg>',
  PADDING: '<pd>',
  BORDER_RADIUS: '<br>',
  DOWNLOAD: '<download>',
};

export const TEMPLATE_VARS_CLOSING = {
  [TEMPLATE_VARS_OPENING.STRIKE_THROUGH]: '</s>',
  [TEMPLATE_VARS_OPENING.BOLD]: '</b>',
  [TEMPLATE_VARS_OPENING.ANCHOR]: '</a>',
  [TEMPLATE_VARS_OPENING.HYPERLINK]: '</h>',
  [TEMPLATE_VARS_OPENING.TEL]: '</t>',
  [TEMPLATE_VARS_OPENING.REPLACE]: '</r>',
  [TEMPLATE_VARS_OPENING.FONT_SIZE]: '</fs>',
  [TEMPLATE_VARS_OPENING.URL]: '</url>',
  [TEMPLATE_VARS_OPENING.STYLE]: '</style>',
  [TEMPLATE_VARS_OPENING.TARGET]: '</target>',
  [TEMPLATE_VARS_OPENING.UNORDERED_LIST]: '</ul>',
  [TEMPLATE_VARS_OPENING.LIST_ITEM]: '</li>',
  [TEMPLATE_VARS_OPENING.MARGIN_LEFT]: '</ml>',
  [TEMPLATE_VARS_OPENING.MARGIN_RIGHT]: '</mr>',
  [TEMPLATE_VARS_OPENING.LINE_HEIGHT]: '</leading>',
  [TEMPLATE_VARS_OPENING.DISPLAY]: '</d>',
  [TEMPLATE_VARS_OPENING.FLEX_DIR]: '</fd>',
  [TEMPLATE_VARS_OPENING.MARGIN]: '</m>',
  [TEMPLATE_VARS_OPENING.GAP]: '</g>',
  [TEMPLATE_VARS_OPENING.TEXT_DECORATION]: '</td>',
  [TEMPLATE_VARS_OPENING.TEXT_DECORATION_STYLE]: '</tds>',
  [TEMPLATE_VARS_OPENING.TEXT_UNDERLINE_OFFSET]: '</tuo>',
  [TEMPLATE_VARS_OPENING.SPAN]: '</span>',
  [TEMPLATE_VARS_OPENING.COLOR]: '</color>',
  [TEMPLATE_VARS_OPENING.FONT_WEIGHT]: '</fw>',
  [TEMPLATE_VARS_OPENING.SRC]: '</src>',
  [TEMPLATE_VARS_OPENING.DIV]: '</div>',
  [TEMPLATE_VARS_OPENING.ICON]: '</icon>',
  [TEMPLATE_VARS_OPENING.UNICODE]: '</unicode>',
  [TEMPLATE_VARS_OPENING.ORDERED_LIST]: '</ol>',
  [TEMPLATE_VARS_OPENING.BG]: '</bg>',
  [TEMPLATE_VARS_OPENING.PADDING]: '</pd>',
  [TEMPLATE_VARS_OPENING.BORDER_RADIUS]: '</br>',
  [TEMPLATE_VARS_OPENING.DOWNLOAD]: '</download>',
  [TEMPLATE_VARS_OPENING.TG]: '</tg>',
};

export const STYLES = {
  NORMAL: 'normal',
  VARIABLE: 'variable',
  STRIKE_THROUGH: 'strikeThrough',
  BOLD: 'bold',
  ANCHOR: 'anchor',
  TEL: 't',
  REPLACE: 'replace',
  HYPERLINK: 'hyperLink',
  FONT_SIZE: 'fontSize',
  URL: 'url',
  STYLE: 'style',
  TARGET: 'target',
  UNORDERED_LIST: 'ul',
  LIST_ITEM: 'li',
  MARGIN_LEFT: 'margin-left',
  MARGIN_RIGHT: 'margin-right',
  MARGIN: 'margin',
  LINE_HEIGHT: 'line-height',
  DISPLAY: 'display',
  FLEX_DIR: 'flex-direction',
  GAP: 'gap',
  TEXT_DECORATION: 'text-decoration',
  TEXT_DECORATION_STYLE: 'text-decoration-style',
  TEXT_UNDERLINE_OFFSET: 'text-underline-offset',
  SPAN: 'span',
  COLOR: 'color',
  FONT_WEIGHT: 'font-weight',
  SRC: 'src',
  DIV: 'div',
  ICON: 'icon',
  UNICODE: 'unicode',
  ORDERED_LIST: 'ol',
  BG: 'bg',
  TEXT_GRADIENT: 'textGradient',
  PADDING: 'padding',
  BORDER_RADIUS: 'border-radius',
  DOWNLOAD: 'download',
};

export const getProps = {
  [STYLES.URL]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { href: value };
  },
  [STYLES.TARGET]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { target: value };
  },
  [STYLES.SRC]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    if (!value) return { src: value };
    // Support optional width/height encoded as: "url|width|height"
    // Example: <src>https://.../img.jpg|200|100</src>
    const parts = value.split('|').map((p) => p?.trim());
    const src = parts[0];
    const width = parts[1] ? Number(parts[1]) : undefined;
    const height = parts[2] ? Number(parts[2]) : undefined;
    return { src, width, height };
  },
  [STYLES.FONT_SIZE]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { fontSize: value };
  },
  [STYLES.MARGIN_LEFT]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { marginLeft: value };
  },
  [STYLES.MARGIN_RIGHT]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { marginRight: value };
  },
  [STYLES.STYLE]: ({ children }) => {
    return {
      style: children.reduce((acc, { type, ...rest }) => {
        return { ...acc, ...(getProps[type]?.(rest) ?? {}) };
      }, {}),
    };
  },
  [STYLES.LINE_HEIGHT]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { lineHeight: value };
  },
  [STYLES.DISPLAY]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { display: value };
  },
  [STYLES.FLEX_DIR]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { flexDirection: value };
  },
  [STYLES.MARGIN]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { margin: value };
  },
  [STYLES.PADDING]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { padding: value };
  },
  [STYLES.GAP]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { gap: value };
  },
  [STYLES.TEXT_DECORATION]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { textDecoration: value };
  },
  [STYLES.TEXT_DECORATION_STYLE]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { textDecorationStyle: value };
  },
  [STYLES.TEXT_UNDERLINE_OFFSET]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { textUnderlineOffset: value };
  },
  [STYLES.COLOR]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { color: value };
  },
  [STYLES.FONT_WEIGHT]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { fontWeight: value };
  },
  [STYLES.UNICODE]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { unicode: value };
  },
  [STYLES.BG]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    if (!value) return { background: value };
    // If the background value contains a gradient, apply text-gradient friendly styles
    const isGradient = String(value).toLowerCase().includes('gradient');
    if (isGradient) {
      return {
        backgroundImage: value,
      };
    }
    return { background: value };
  },
  [STYLES.TEXT_GRADIENT]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    if (!value) return {};
    return {
      backgroundImage: value,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',

      '--tg-bg': value, // Store the gradient in a CSS variable for inheritance by child elements that also use text gradients
      '--tg-fill': 'transparent',
    };
  },
  [STYLES.BORDER_RADIUS]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { borderRadius: value };
  },
  [STYLES.DOWNLOAD]: ({ children }) => {
    const value = children.find(({ type }) => type === STYLES.NORMAL)?.value;
    return { download: value || true };
  },
};

export const TEMPLATE_VARS_REVERSE_MAPPING = {
  [TEMPLATE_VARS_OPENING.STRIKE_THROUGH]: STYLES.STRIKE_THROUGH,
  [TEMPLATE_VARS_OPENING.BOLD]: STYLES.BOLD,
  [TEMPLATE_VARS_OPENING.ANCHOR]: STYLES.ANCHOR,
  [TEMPLATE_VARS_OPENING.TEL]: STYLES.TEL,
  [TEMPLATE_VARS_OPENING.REPLACE]: STYLES.REPLACE,
  [TEMPLATE_VARS_OPENING.HYPERLINK]: STYLES.HYPERLINK,
  [TEMPLATE_VARS_OPENING.FONT_SIZE]: STYLES.FONT_SIZE,
  [TEMPLATE_VARS_OPENING.STYLE]: STYLES.STYLE,
  [TEMPLATE_VARS_OPENING.URL]: STYLES.URL,
  [TEMPLATE_VARS_OPENING.TARGET]: STYLES.TARGET,
  [TEMPLATE_VARS_OPENING.UNORDERED_LIST]: STYLES.UNORDERED_LIST,
  [TEMPLATE_VARS_OPENING.LIST_ITEM]: STYLES.LIST_ITEM,
  [TEMPLATE_VARS_OPENING.MARGIN_LEFT]: STYLES.MARGIN_LEFT,
  [TEMPLATE_VARS_OPENING.LINE_HEIGHT]: STYLES.LINE_HEIGHT,
  [TEMPLATE_VARS_OPENING.DISPLAY]: STYLES.DISPLAY,
  [TEMPLATE_VARS_OPENING.FLEX_DIR]: STYLES.FLEX_DIR,
  [TEMPLATE_VARS_OPENING.MARGIN]: STYLES.MARGIN,
  [TEMPLATE_VARS_OPENING.GAP]: STYLES.GAP,
  [TEMPLATE_VARS_OPENING.TEXT_DECORATION]: STYLES.TEXT_DECORATION,
  [TEMPLATE_VARS_OPENING.TEXT_DECORATION_STYLE]: STYLES.TEXT_DECORATION_STYLE,
  [TEMPLATE_VARS_OPENING.TEXT_UNDERLINE_OFFSET]: STYLES.TEXT_UNDERLINE_OFFSET,
  [TEMPLATE_VARS_OPENING.SPAN]: STYLES.SPAN,
  [TEMPLATE_VARS_OPENING.COLOR]: STYLES.COLOR,
  [TEMPLATE_VARS_OPENING.FONT_WEIGHT]: STYLES.FONT_WEIGHT,
  [TEMPLATE_VARS_OPENING.SRC]: STYLES.SRC,
  [TEMPLATE_VARS_OPENING.DIV]: STYLES.DIV,
  [TEMPLATE_VARS_OPENING.ICON]: STYLES.ICON,
  [TEMPLATE_VARS_OPENING.UNICODE]: STYLES.UNICODE,
  [TEMPLATE_VARS_OPENING.ORDERED_LIST]: STYLES.ORDERED_LIST,
  [TEMPLATE_VARS_OPENING.BG]: STYLES.BG,
  [TEMPLATE_VARS_OPENING.PADDING]: STYLES.PADDING,
  [TEMPLATE_VARS_OPENING.BORDER_RADIUS]: STYLES.BORDER_RADIUS,
  [TEMPLATE_VARS_OPENING.DOWNLOAD]: STYLES.DOWNLOAD,
  [TEMPLATE_VARS_OPENING.TG]: STYLES.TEXT_GRADIENT,
};
